<div class="mb-6 flex flex-wrap items-center justify-between gap-4 pt-10">
  <div class="flex flex-wrap gap-4">
    @for (category of getCategories(); track category) {
      <button
        class="btn btn-outline"
        [ngClass]="{ 'btn-active': selectedCategory() === category }"
        [attr.aria-pressed]="selectedCategory() === category"
        (click)="selectCategory(category)"
      >
        {{ category }}
      </button>
    }
  </div>
  <a class="btn-secondary btn" [href]="'mailto:websupport@denhollander.info'">
    {{ 'pages.helpPage.askQuestion' | translate }}
  </a>
</div>
